import { render } from "./AsMenu.vue?vue&type=template&id=3b04258d&ts=true"
import script from "./AsMenu.vue?vue&type=script&lang=ts"
export * from "./AsMenu.vue?vue&type=script&lang=ts"

import "./AsMenu.vue?vue&type=style&index=0&id=3b04258d&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__